import {inject, provideAppInitializer} from '@angular/core';
import {Actions, ofActionDispatched} from '@ngxs/store';
import {HttpClient} from '@angular/common/http';
import {catchError, EMPTY, switchMap, withLatestFrom} from 'rxjs';
import {getApiUrl} from '../helpers/env.helper';
import {ReadNotificationsAction} from '../../notifications/+state/actions';

export const readNotificationInit = provideAppInitializer(() => {
  const actions = inject(Actions);
  const httpClient = inject(HttpClient);

  actions.pipe(
    ofActionDispatched(ReadNotificationsAction),
    withLatestFrom(getApiUrl('notifications')),
    switchMap(([{ids}, url]) =>
      httpClient.put(url, {ids: Array.isArray(ids) ? ids : [ids]}).pipe(
        catchError(err => {
          console.error('Error reading notifications', err);
          return EMPTY;
        })
      )
    )
  ).subscribe();
});
